import React from 'react';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';
import type { ProjectContext } from '@atlassian/jira-router-resources-project-context/src/services/project-context/types.tsx';
import { ExternalLinks } from '@atlassian/jira-servicedesk-external-links';
import { ServiceDeskDocumentTitle } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/document-title/index.tsx';
import AppContainer from '@atlassian/jira-spa-apps-project-settings-common/src/components/app-container';

export type Props = {
	projectContext: ProjectContext | null;
};

export const ServiceDeskExternalLinks = (props: Props) => {
	const { projectContext } = props;

	if (!projectContext) {
		return <Spinner />;
	}

	const { projectId, projectKey, projectName } = projectContext;

	return (
		<>
			<ServiceDeskDocumentTitle projectName={projectName} section="externalLinks" />
			<AppContainer baseUrl="" projectKey={projectKey}>
				<ExternalLinks projectId={projectId.toString()} />
			</AppContainer>
		</>
	);
};
export default ServiceDeskExternalLinks;
